// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function getPartReturn(id) {

    const endPoint = `${basePath}/part-returns/${id}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getPartReturns(payload) {

    const endPoint = payload.export === 'EXCEL' ?
        `${basePath}/part-returns/collection?export=EXCEL` :
        `${basePath}/part-returns/collection`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return payload.export === 'EXCEL' ?
            response :
            response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function updatePartRequest(partRequest) {

    const endPoint = `${basePath}/part-returns/${partRequest.id}`;

    const fetchOptions = {
        body: JSON.stringify(partRequest),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function getSearchResults(searchQueryString, searchBy) {

    const endPoint = `${basePath}/part-returns/search?by=${searchBy}&q=${encodeURIComponent(searchQueryString)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getRgaSubtypes() {

    const endPoint = `${basePath}/constants?id=RGA_SUBTYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/part-requests/shared/repositories/index.js